export default __webpack_public_path__ + "5d49305dedfa9a2f17960bf6711da589.woff2?proxy=wpt-abc";